import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';
import { WithContext as ReactTags } from 'react-tag-input';
import { Modal, ModalBody, ModalFooter, Button, Collapse} from 'reactstrap';
import QRCode from 'qrcode.react';
import UploadFile from '../includes/UploadFile';
import Loader from 'react-loader-spinner';
import Analytics from "../common/Analytics";
import Gallery from "./Gallery";
import NewItemAdd from "./NewItemAdd";
import AuthService from '../../lib/AuthService';
import {PUB_PLAYER_PATH, UNPUB_PLAYER_PATH} from "../../constants";
import ReactImageFallback from "react-image-fallback";
import VignetNewItem from "./VignetNewItem";

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class DetailContainer extends Component {

    constructor(props) {
        super(props);


        this.state = {
            value: '',
            textNote : '',
            showPop : false,
            showQR : false,
            copyUrl : false,
            showaddProject : false,
            vignetTags : [],
            newTag : '',
            newProject : '',
            image_path: null,
            showShareOptions : false,
            activeTab : 'overview',
            projects : '',
            delprojects :[],
            deltags : [],
            newTags : [],
            tags : '',
            showAddnote: false,
            NoteErrorMsg : false,
            QrUrl : '',
            showPass : false,
            tagStatus : "save",
            vignet_password : '',
            passMessage : 'Password is required',
            confirmResetPass : false,
            vignetPassSet : false
        };
        this.Auth = new AuthService();
        this.getDetail = this.getDetail.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleProjectDelete = this.handleProjectDelete.bind(this);
        this.handleProjectAddition = this.handleProjectAddition.bind(this);
        this.handleProjectDrag = this.handleProjectDrag.bind(this);
        this.showSharePop = this.showSharePop.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.qToggle = this.qToggle.bind(this);
        this.cToggle = this.cToggle.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
        this.downloadQRCode = this.downloadQRCode.bind(this);
        this.saveTags = this.saveTags.bind(this);
        this.saveProjects = this.saveProjects.bind(this);
        this.toggle = this.toggle.bind(this);
        this.addNewproject = this.addNewproject.bind(this);
        this.showAddnoteModal = this.showAddnoteModal.bind(this);
        this.handleTagChange = this.handleTagChange.bind(this);
        this.handleProjectChange = this.handleProjectChange.bind(this);
        this.showAddProjectModal = this.showAddProjectModal.bind(this);
        this.showAddTagsModal = this.showAddTagsModal.bind(this);
        this.setQrUrl = this.setQrUrl.bind(this);

    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getDetail();
        /* let data = { userid : this.Auth.getProfile().user_id, 'le_id' : this.props.match.params.id  };
         this.props.getDetail(data);*/

        this.setState({vignet_id: this.props.match.params.id});

        let prop_params = { vignet_id : this.props.match.params.id, section : 'detail', index : 0 , section_name : 'detail' };

        this.props.getVignetsProps(prop_params);

        let vig_params = { vigid : this.props.match.params.id };

        this.props.getVignetTags(vig_params);

        let prj_params = { vigid : this.props.match.params.id };

        this.props.getVignetProjects(prj_params);

        this.props.getVignetNotes(vig_params);


    }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):

        if (this.props.vignetsData.vignetTags !== prevProps.vignetsData.vignetTags) {
            this.setState(
                {
                    tags: this.props.vignetsData.vignetTags,
                    newTags: this.props.vignetsData.vignetTags,
                    tagStatus     : "Save"
                }
            );
        }

        if (this.props.vignetsData.vignetProjects !== prevProps.vignetsData.vignetProjects) {

            this.setState(
                {
                    projects: this.props.vignetsData.vignetProjects,
                    projectStatus     : "Save"
                }
            );
        }

        if ( this.props.vignetsData.tagsAdded !== prevProps.vignetsData.tagsAdded || this.props.vignetsData.tagsRemoved !== prevProps.vignetsData.tagsRemoved ){

            let vig_params = { vigid : this.props.match.params.id };
            // console.log(data)
            this.props.getVignetTags(vig_params);
            this.setState({editTag : false});
        }

        if ( this.props.vignetsData.projectAdded !== prevProps.vignetsData.projectAdded || this.props.vignetsData.projectRemoved !== prevProps.vignetsData.projectRemoved ){
            this.getDetail()
            let prj_params = { vigid : this.props.match.params.id };
            // console.log(data)
            this.props.getVignetProjects(prj_params);
            this.setState({editProject : false});
        }

        if ( this.props.vignetsData.noteAdded !== prevProps.vignetsData.noteAdded ){
            let vig_params = { vigid : this.props.match.params.id };
            this.props.getVignetNotes(vig_params);
        }

        if(this.props.playlistData.newImage !== prevProps.playlistData.newImage ) {
            this.setState({image_path : this.props.playlistData.newImage});
        }
        if(this.props.vignetsData.vignetDetail !== prevProps.vignetsData.vignetDetail) {
            let vignet = this.props.vignetsData.vignetDetail;
            let playerUrl = '';
            if(vignet.public_view === 1) {
                playerUrl = PUB_PLAYER_PATH+ vignet.vignet_id+'/';
            }
            else{
                playerUrl = UNPUB_PLAYER_PATH+ vignet.vignet_id+'///';
            }

            let vignetPassSet = ( vignet.passwordSet === 'yes') ? true : false;

            this.setState({playerUrl : playerUrl, vignetPassSet :vignetPassSet});
            this.setQrUrl();
        }

        if ( this.props.vignetsData.vignetPassSet !== prevProps.vignetsData.vignetPassSet ){
            this.setState({ vignetPassSet : true });
        }

        if ( this.props.vignetsData.vignetPassReset !== prevProps.vignetsData.vignetPassReset ){
            this.setState({ vignetPassSet : false });
        }


    }
    setQrUrl(){
        let vignet = this.props.vignetsData.vignetDetail;
        let QrUrl = PUB_PLAYER_PATH+ vignet.vignet_id+'/';
        this.setState({QrUrl : QrUrl});
    }


    getDetail(){
        let data = { userid : this.Auth.getProfile().user_id ,'le_id' : this.props.match.params.id };
        this.props.getDetail(data);
    }

    editTags() {
        this.setState({editTag : true});
    }

    editProjects() {
        this.setState({editProject : true});
    }

    cancelEdit(){
        this.setState({editTag : false});
    }
    cancelProjectEdit(){
        this.setState({editProject : false});
    }


    handleDelete(i) {
        let tags  = this.state.newTags;
        let deltags  = this.state.deltags;

        if(tags) {
            deltags.push(tags[i]);
            let newTags = tags.filter((tag, index) => index !== i);
            this.setState({
                newTags: newTags,
                deltags : deltags
            });
	    let data = {le_id : this.state.vignet_id, tag_name : tags[i].text, tags: JSON.stringify(newTags)};
            this.props.removeTags(data);

        }

    }

    handleAddition(tag) {
        this.setState(state => ({ tags: [...state.tags, tag] }));

        let data = {le_id : this.state.vignet_id, tag_name : tag.text};
        this.props.saveTags(data);

        this.setState({tagStatus : "Processing..."})
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    handleInputBlur(tagText) {
        this.setState({ newTag: tagText });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    saveTags() {
        if(this.state.newTag !== "") {
            let data = {le_id: this.state.vignet_id, tag_name: this.state.newTag};
            this.props.saveTags(data);
        }
        if(this.state.deltags) {
            let deletedTags = this.state.deltags;
            deletedTags.map(tag => {
                let data = {le_id : this.state.vignet_id, tag_name : tag.text, tags: JSON.stringify(this.state.newTags)};
                this.props.removeTags(data);
            })
        }
    }

    saveNote() {
        if(this.state.textNote !== '') {
            let data = {userid : this.Auth.getProfile().user_id, vigid : this.state.vignet_id, note : this.state.textNote};
            this.props.saveNote(data);
            this.setState({textNote : '', showAddnote:false, NoteErrorMsg:false});
        } else{
            this.setState({NoteErrorMsg:true});
        }


    }

    /************************Project ***************************/
    handleProjectDelete(i) {
        let projects  = this.state.projects;
        let delprojects  = this.state.delprojects;
        if(projects) {
            delprojects.push(projects[i]);
            let newProjects = projects.filter((project, index) => index !== i);

            this.setState({
                projects: newProjects,
                delprojects : delprojects
            });

            /*let data = {le_id : this.state.vignet_id, project_name : projects[i].text, projects: JSON.stringify(newProjects)};
            this.props.removeProjects(data);*/
        }

    }

    handleProjectAddition(project) {
        this.setState(state => ({ projects: [...state.projects, project] }));

        let data = {le_id : this.state.vignet_id, project_name : project.text, userid : this.Auth.getProfile().user_id};
        this.props.saveProjects(data);

        this.setState({projectStatus : "Processing..."})
    }

    handleProjectDrag(project, currPos, newPos) {
        const projects = [...this.state.projects];
        const newProjects = projects.slice();

        newProjects.splice(currPos, 1);
        newProjects.splice(newPos, 0, project);

        // re-render
        this.setState({ projects: newProjects });
    }

    handleProjectChange(projectText) {
        this.setState({ newProject: projectText });
    }
    handleTagChange(projectText) {
        this.setState({ newTag: projectText });
    }


    saveProjects() {
        if(this.state.newProject !== "") {
            let data = {le_id: this.state.vignet_id, project_name: this.state.newProject, userid : this.Auth.getProfile().user_id};
            this.props.saveProject(data);
        }

        if(this.state.delprojects) {
            let deletedProjects = this.state.delprojects;
            deletedProjects.map(project => {
                let data = {le_id : this.state.vignet_id, project_name : project.text, projects: JSON.stringify(this.state.projects)};
                this.props.removeProjects(data);
            })
        }


    }

    /*************************Project End *************************/

    showSharePop() {
        this.setState({showShareOptions : !this.state.showShareOptions});
    }

    mToggle() {
        this.setState({
            showPop: !this.state.showPop
        });
    }
    showAddnoteModal(){
        this.setState({
            showAddnote: !this.state.showAddnote
        });
    }
    cToggle() {
        this.setState({
            copyUrl: !this.state.copyUrl
        });
    }

    qToggle() {
        this.setState({
            showQR: !this.state.showQR
        });
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.Auth.getProfile().user_id;

        var e = document.createElement("textarea");
        var url = this.state.playerUrl+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {


       // var baseUrl =String(this.state.playerUrl+vignet_id);
        var baseUrl =String(this.state.playerUrl);
        let rootUrl = '';let shareUrl ='';


        if(type === 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type === 'wa') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type === 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }
        window.open(shareUrl,'_blank',"toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=400");

    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {
        this.setState({
            showQR : true
        });

    }

    downloadQRCode() {
        let vignet_id = this.state.vignet_id;
        var canvas = document.querySelector( 'canvas' );
        var link = document.createElement('a');
        link.innerHTML = 'Download';
        link.addEventListener('click', function(ev) {
            link.href = canvas.toDataURL();
            link.download = vignet_id+".png";
        }, false);
        document.body.appendChild(link);
        link.click();
    }

    getUploadedFile(fileName) {
        this.setState({
            image_path: fileName
        });
        //Request to purging
        this.props.getImagepurged({image_name : 'cf'+this.state.vignet_id, image_path : fileName});

    }
    addNewproject(){

        this.setState({ showaddProject: !this.state.showaddProject,});
    }
    toggle() {
        this.setState({
            showGraphMessage: !this.state.showGraphMessage,
            alertMessage : ''
        });
    }
    /*exportVignet() {

        const url = "https://devvigapiv1.vignets.com/builder/exporttext";
        const data = { vig_id : "5dc3fc707b39e", userid : "u5d4d1e8f76801"};

        fetch(url, {
            method: 'POST',
            supportHeaderParams: true,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin":"*"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.text())
            .then(
                (result) => {
                    console.log(result);
                },
                (error) => {
                    //console.log('Error - ' + error)
                }
            );

    }*/
    changeTab(tabname) {
        this.setState({ activeTab : tabname})
    }
    changeTab(tabname) {
        this.setState({ activeTab : tabname})
    }
    showAddProjectModal(){
        this.props.modalToggle({
            modalOpen: true,
            modalTitle: "Add New Project",
            modalType: "new-vig-project"
        });
        this.setState({ projects: this.props.vignetsData.vignetProjects,})
    }
    showAddTagsModal(){
        this.props.modalToggle({
            modalOpen: true,
            modalTitle: "Add New Tag",
            modalType: "new-vig-tag"
        });
        this.setState({ newTags: this.props.vignetsData.vignetTags})

    }

    showPasswordModal = () => {
        this.setState({
            showPass : true
        })
    }
    hidePasswordModal = () => {
        this.setState({
            showPass : false
        })
    }
    handlePassword = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    savePassword = () => {
        if(this.state.vignet_password !== '') {
            if(this.state.vignet_password.length <4){
                this.setState({PassErrorMsg:true, passMessage : 'The password should contain atleast 4 characters'});
            }else{
                let data = {vignet_id : this.state.vignet_id, password : this.state.vignet_password};
                this.props.saveVignetPassword(data);
                this.setState({vignet_password : '', showPass:false, PassErrorMsg:false});
            }

        } else{
            this.setState({PassErrorMsg:true, passMessage : 'Password is required'});
        }
    }

    showResetPass = () => {
        this.setState({confirmResetPass : true})
    }

    hideResetPass = () => {
        this.setState({confirmResetPass : false})
    }
    resetVignetPass = () => {
        let data = {vignet_id : this.state.vignet_id};
        this.props.removeVignetPassword(data);
        this.hideResetPass()
    }


    render() {

        const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/{builderUrl}'/>;
        }

        let vignet = this.props.vignetsData.vignetDetail;
console.log(this.props.vignetsData);

        // let graphData =  this.props.vignetsData.graphData?this.props.vignetsData.graphData:[];

        let fbViewCount =  this.props.vignetsData.fbViewCount?this.props.vignetsData.fbViewCount:0;
        let waViewCount =  this.props.vignetsData.waViewCount?this.props.vignetsData.waViewCount:0;
        let fbShareCount =  this.props.vignetsData.fbShareCount?this.props.vignetsData.fbShareCount:0;
        let waShareCount =  this.props.vignetsData.waShareCount?this.props.vignetsData.waShareCount:0;


        let builderUrl = '';
        let playerUrl = '';
        let img_name = '';
        if(vignet ) {
            builderUrl = this.props.pageSettingsData.config.BUILDER_PATH+ vignet.vignet_id+'/'+this.Auth.getProfile().user_id;
            if(vignet.public_view === 1) {
                playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ vignet.vignet_id+'/';
            }
            else{
                playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ vignet.vignet_id+'///';
            }
            img_name = vignet.vignet_id;
        }
        let profileImgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+this.Auth.getProfile().user_id+'.jpg'
        let imgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/cf'+img_name+'.jpg';

        let vignetNotes = this.props.vignetsData.vignetNotes?this.props.vignetsData.vignetNotes:undefined;
        let defImgSrc = '/assets/images/no-gallery.jpg';

        let vignetPassSet = this.state.vignetPassSet;
        return (

            <div className="content-tab">
                <ul className="nav nav-tabs nav-4-item" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className={"nav-link vign-ico " + ((this.state.activeTab==='overview') ? ' active' : '')}  id="home-tab" data-toggle="tab"  role="tab"
                           aria-controls="home" aria-selected="true" onClick={()=>this.changeTab('overview')}>Overview</a>
                    </li>
                    <li className="nav-item">
                        <a className={"nav-link any-ico " + ((this.state.activeTab==='analytics') ? ' active' : '')} id="profile-tab" data-toggle="tab" role="tab"
                           aria-controls="profile" aria-selected="false" onClick={()=>this.changeTab('analytics')}>Analytics</a>
                    </li>
                    <li className="nav-item">
                        <a className={"nav-link res-ico " + ((this.state.activeTab==='response') ? ' active' : '')} id="contact-tab" data-toggle="tab" role="tab"
                           aria-controls="contact" aria-selected="false" onClick={()=>this.changeTab('response')}>Responses</a>
                    </li>
                    <li className="nav-item">
                        <a className={"nav-link res-ico " + ((this.state.activeTab==='gallery') ? ' active' : '')} id="gallery-tab" data-toggle="tab" role="tab"
                           aria-controls="gallery" aria-selected="false" onClick={()=>this.changeTab('gallery')}>Gallery</a>
                    </li>
                </ul>
                {!vignet &&
                <div className="loaderWrapper">
                    <Loader type="ThreeDots" color="#54a1d7"  height="50" width="50"/>
                </div>
                }

                {vignet &&
                <div className="tab-content" id="myTabContent">
                    <div className= {"tab-pane show fade overiew-padng" + ((this.state.activeTab==='overview') ? ' active' : '')} id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div className="main-header-panel">
                            <div className="header-panel-left">

                                <div className="image-up">

                                    {this.state.image_path &&
                                    <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="vignet"/>
                                    }
                                    {this.state.image_path ===null &&
                                    <ReactImageFallback
                                        className="my-image"
                                        src={imgSrc}
                                        fallbackImage={defImgSrc}
                                        initialImage={defImgSrc}
                                        alt="cool image should be here"
                                    />
                                    }
                                    {vignet.user_id == this.Auth.getProfile().user_id &&
                                    <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add"
                                                item_type="VIGNETS"
                                                unique_id={(this.props.vignetsData && this.props.vignetsData.vignetDetail && this.props.vignetsData.vignetDetail.vignet_id) ? 'cf' + this.props.vignetsData.vignetDetail.vignet_id : ''}/>
                                    }
                                    {this.state.image_path ===null && this.props.uploadData.loader === true &&
                                    <div id="progress-bar-wrapper"></div>
                                    }
                                    {this.props.uploadData.errors === true &&
                                    <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                    }

                                </div>

                            </div>
                            <div className="header-panel-right">
                                <div className = {this.state.editTag ? "detail-left description" : "detail-left non-edit description"}>
                                    <h5>{vignet.vignet_title}</h5>
                                    <p>{vignet.description}</p>
                                    <ul className="info-txt">
                                        <li>{vignet.user_name} created on {vignet.created_date}</li>
                                        {vignet.category !== '' && vignet.category !== null &&
                                        <li>CATEGORY - {vignet.vig_category}</li>
                                        }
                                    </ul>

                                </div>
                                <div className="detail-right">
                                    <div className="status-wrap">
                                        <div className="ind-status">
                                            <span>VIEWS</span>
                                            <a href={playerUrl} target="_blank">
                                                <button className="status-option ico-lib option-preview"></button>
                                            </a>
                                            <h5>{vignet ? vignet.eventTracks.view_count:0}</h5>
                                        </div>
                                        <div className="ind-status">
                                            <span>SHARES</span>
                                            <div className={"button-wrap"} style={{position: 'relative'}}>
                                                <button className="status-option ico-lib option-upload" onClick={()=>this.showSharePop()}
                                                        ></button>
                                            </div>




                                            <h5>{vignet ? vignet.eventTracks.share_count:0}</h5>
                                        </div>
                                        <div className="ind-status">
                                            <span>CLICKS</span>
                                            <h5>{vignet ? vignet.eventTracks.click_count:0}</h5>
                                        </div>

                                    </div>
                                    <Collapse isOpen={this.state.showShareOptions}>
                                        <ul id="collapse-share-options" className="upload">
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-face" onClick={() => {this.shareToFb('fb',vignet.vignet_id)}}>Facebook</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-whatsapp" onClick={() => {this.shareToFb('wa',vignet.vignet_id)}}>Whatsapp</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-email" onClick={() => {this.shareToFb('em',vignet.vignet_id, vignet.vignet_title)}}>Email</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-embed" onClick={() => {this.showWebModal(vignet.vignet_id, vignet.vignet_title)}}>Copy Embed Code</a>

                                            </li>
                                            {vignet.public_view === 1 &&
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-qr"
                                                   onClick={() => {
                                                       this.showQRModal(vignet.vignet_id)
                                                   }}>QR Code</a>
                                            </li>
                                            }
                                        </ul>
                                    </Collapse>

                                </div>
                            </div>
                            <div className="status-option-wrap detail-icons editcontent">
                                {/*<button className="status-option ico-lib" onClick={this.exportVignet}>Export</button>-*/}

                                {vignet.user_id == this.Auth.getProfile().user_id &&
                                <a href={builderUrl} target="_blank">
                                    <button className="status-option edit-btn"><label>Edit Content</label></button>
                                </a>
                                }
                                {vignet.user_id === this.Auth.getProfile().user_id && !vignetPassSet &&
                                    <button className="status-option edit-btn"
                                            onClick={() => this.showPasswordModal()}>
                                        <label>Set Password</label>
                                    </button>
                                }
                                {vignet.user_id == this.Auth.getProfile().user_id && vignetPassSet &&
                                    <button className="status-option edit-btn"
                                            onClick={() => this.showResetPass()}>
                                        <label>Reset Password</label>
                                    </button>
                                }

                            </div>
                        </div>

                        <div className="note-wrapper left-section">
                            <div className={'note-header-wrap'}>
                                <h5 className="note-header">Notes <span>({vignetNotes ? vignetNotes.length : '0'})</span></h5>
                                {vignet.user_id == this.Auth.getProfile().user_id &&
                                <button className="btn-add-project" type="button" onClick={() => {
                                    this.showAddnoteModal()
                                }}> + </button>
                                }
                            </div>
                            {vignetNotes ?

                                vignetNotes.map((note, index) => {
                                let profileImgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/'+note.pub_user+'.jpg'
                                return(
                                    <div className="ind-note comment">
                                        <div className="added-comment-panel">
                                            <div className="added-comment-left">
                                                <div className="com-user-thumb">
                                                    <ReactImageFallback
                                                        className="my-image"
                                                        src={profileImgSrc}
                                                        fallbackImage={defImgSrc}
                                                        initialImage={defImgSrc}
                                                        alt="cool image should be here"
                                                    />
                                                </div>
                                                <div className="com-user-det">
                                                    <h5>{note.user_name}</h5>
                                                    <p>{note.publish_date}</p>
                                                </div>
                                            </div>
                                            <div className="added-comment-right">
                                                <p>&nbsp;</p>
                                            </div>
                                        </div>
                                        <div className="commented-text">
                                            <p className="comnt-txt-sub" >{note.pub_note}</p>
                                        </div>
                                    </div>
                                );
                            }) :
                              <div className="empty-vig-content emp-notes"> <p>Notes not added yet</p></div>
                            }

                        </div>
                        <div className="note-wrapper right-section">
{/*

                            <div className="project-section projects">
                                <h5 className="project-header">Projects</h5>

                                { vignet.user_id == this.Auth.getProfile().user_id &&
                                <button className="btn-add-project" type="button" onClick={() => {
                                    this.showAddProjectModal()
                                }}>+</button>
                                }
                                {this.state.showaddProject && <NewItemAdd/> } {this.state.showaddProject}


                                {this.props.vignetsData.modalType === "new-vig-project" &&
                                <NewItemAdd
                                    dataList={this.state.projects}
                                    handleDelete={this.handleProjectDelete}
                                    handleAddition={this.handleProjectAddition}
                                    handleDrag={this.handleProjectDrag}
                                    handleInputChange={this.handleProjectChange}
                                    saveItems={this.saveProjects}
                                    buttonStatus={this.state.projectStatus}
                                    cancelEdit={this.cancelProjectEdit}
                                    placeholder={`Add new project`}

                                />
                                }




                                <div className="project-list">
                                    {vignet.projects.length !== 0 ?
                                        <ul class="project-content">
                                            { vignet.projects.map((prjcts, index) =>
                                            <li>{prjcts.project_name}</li>
                                            )}
                                        </ul> :
                                        <div className="empty-vig-content"> <p>Projects not added yet</p></div>
                                    }

                                </div>
                            </div>
*/}

                            <div className="project-section tag">
                                <h5 className="project-header">Tags</h5>
                                {vignet.user_id == this.Auth.getProfile().user_id &&
                                <button className="btn-add-project" type="button"  onClick={() => {
                                    this.showAddTagsModal()
                                }}>+</button>

                                }
                                {this.props.vignetsData.modalType === "new-vig-tag" &&
                                <NewItemAdd
                                    dataList={this.state.newTags}
                                    handleDelete={this.handleDelete}
                                    handleAddition={this.handleAddition}
                                    handleDrag={this.handleDrag}
                                    handleInputChange={this.handleTagChange}
                                    saveItems={this.saveTags}
                                    buttonStatus={this.state.tagStatus}
                                    cancelEdit={this.cancelEdit}
                                    placeholder={`Add new tag`}

                                />
                                }
                                <div className="project-list">

                                        {this.state.tags.length !== 0 ?
                                            <ul className="project-content tags">
                                                {this.state.tags.map((tag, index) =>
                                                <li>#{tag.text}</li>
                                            )}
                                            </ul>
                                                :

                                            <div className="empty-vig-content"> <p>Tags not added yet</p></div>
                                        }

                                </div>
                            </div>


                        </div>

                    </div>

                    <div className={"tab-pane show fade" + ((this.state.activeTab==='analytics') ? ' active' : '')} id="profile" role="tabpanel" aria-labelledby="profile-tab"><Analytics />

                        <div className="vignet-detail-panel">
                            <div className="sort-wraper">
                                {/*<div className="dropdown custom-dropdown">
                                            <button className="filter-btn">Plot Rows</button>
                                            <label>Sort Type: </label>
                                            <button className="custom-drop dropdown-toggle" type="button" id="dropdownMenu2"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Default
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMenu2"
                                                 x-placement="bottom-start"
                                                 style={{
                                                     position: 'absolute',
                                                     transform: 'translate3d(46px, 34px, 0px)',
                                                     top: '0px',
                                                     left: '0px',
                                                     willChange: 'transform'
                                                 }}>
                                                <button className="dropdown-item" type="button">Default</button>
                                                <button className="dropdown-item" type="button">Modified Type A</button>
                                                <button className="dropdown-item" type="button">Modified Type B</button>
                                            </div>
                                        </div>*/}
                                {/*  <div className="search-block">
                                            <input type="text" className="search-box" placeholder="Search"/>
                                            <button className="search-btn icon-lib search-ico"></button>
                                        </div>*/}

                            </div>
                        </div>
                        <div className="vignet-table-block">
                            <table className="table vignet-table">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Platform</th>
                                    <th>Views</th>
                                    <th>Shares</th>
                                    <th>Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        {/*<div className="check-wrapper">
                                                    <input type="checkbox" name="vig-select" className="check-input"/>
                                                    <label className="check-lbl"></label>
                                                </div>*/}
                                    </td>
                                    <td>Facebook</td>
                                    <td>{fbViewCount}</td>
                                    <td>{fbShareCount}</td>
                                    <td>{fbViewCount+fbShareCount}</td>
                                </tr>
                                <tr>
                                    <td>
                                        {/*<div className="check-wrapper">
                                                    <input type="checkbox" name="vig-select" className="check-input"/>
                                                    <label className="check-lbl"></label>
                                                </div>*/}
                                    </td>
                                    <td>Whatsapp</td>
                                    <td>{waViewCount}</td>
                                    <td>{waShareCount}</td>
                                    <td>{waViewCount+waShareCount}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className= {"tab-pane show fade" + ((this.state.activeTab==='response') ? ' active' : '')} id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
                    <div className= {"tab-pane show fade" + ((this.state.activeTab==='gallery') ? ' active' : '')} id="contact" role="tabpanel" aria-labelledby="gallery-tab">
                        <Gallery vigntid = {this.state.vignet_id}  />
                    </div>
                </div>
                }
                {this.state.showPop &&

                <Modal isOpen={this.state.showPop} toggle={this.mToggle} centered={true} >



                    {/*<div className="md-op">
                            <button type="button" className="close md-close" data-dismiss="modal" onClick={this.mToggle}></button>

                            <div className="share-block social-share">
                                <button className="share-button fb" title="Facebook" onClick={() => {this.shareToFb('fb',vignet.vignet_id)}}></button>
                                <button className="share-button wa" title="Whatsapp" onClick={() => {this.shareToFb('wa',vignet.vignet_id)}}></button>
                                <button className="share-button email" title="Email" onClick={() => {this.shareToFb('em',vignet.vignet_id, vignet.vignet_vignet_title)}}></button>
                                <button className="share-button web" title="Embeded Code" onClick={() => {this.showWebModal(vignet.vignet_id, vignet.vignet_vignet_title)}}></button>
                                <button className="share-button qr" title="QR Code" onClick={() => {this.showQRModal(vignet.vignet_id)}}></button>
                            </div>

                        </div>*/}
                </Modal>
                }

                {this.state.copyUrl &&

                <Modal isOpen={this.state.copyUrl} toggle={this.cToggle} >
                    <ModalBody>
                        <div className="alert alert-danger text-center" role="alert">
                            The link copied to clipboard. {this.state.copyUrl}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.cToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }

                {this.state.showAddnote &&

                <Modal isOpen={this.state.showAddnote}  >

                    <ModalBody>
                        <div className="ind-note new-note-block note-error">
                            <div className="ind-note-left">
                                <ReactImageFallback
                                    className="my-image"
                                    src={profileImgSrc}
                                    fallbackImage={defImgSrc}
                                    initialImage={defImgSrc}
                                    alt="cool image should be here"
                                />

                            </div>
                            <div className="ind-note-right">
                                <textarea placeholder="Drop a note to remind yourself."  type="textarea" name="textNote" id="textNote" value={this.state.textNote}  onChange={this.handleInputChange} ></textarea>
                            </div>

</div>
                        {this.state.NoteErrorMsg &&
                        <div className="note-error-message"><p>Note is required</p></div>
                        }

                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => {this.saveNote()}} >Save</Button>
                        <Button color="secondary" onClick={this.showAddnoteModal}>Close</Button>
                    </ModalFooter>

                </Modal>
                }

                {this.state.showPass &&

                <Modal isOpen={this.state.showPass}  >

                    <ModalBody>
                            <div className="input-select">
                                <input type="password" placeholder="Set a Password" name="vignet_password" id="vignet_password" value={this.state.vignet_password}  onChange={(e) => this.handlePassword(e)} />
                            </div>

                        {this.state.PassErrorMsg &&
                        <div className="note-error-message"><p>{this.state.passMessage}</p></div>
                        }

                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => {this.savePassword()}} >Save</Button>
                        <Button color="secondary" onClick={this.hidePasswordModal}>Close</Button>
                    </ModalFooter>

                </Modal>
                }



                {this.state.showQR &&

                <Modal isOpen={this.state.showQR} toggle={this.qToggle} className="md-width">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">

                            <QRCode value={this.state.QrUrl}/>

                        </div>
                        <div className="modal-adduser-content-btn">
                            <div className="modal-btn btn-cancel">
                                <a href="javascript:void(0);" className="" onClick={this.downloadQRCode}>Download</a>
                            </div>
                            <div className="modal-btn btn-create">
                                <a href="javascript:void(0);" onClick={this.qToggle} className="">Close</a>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                }

                {this.state.confirmResetPass &&

                <Modal isOpen={this.state.confirmResetPass} id="live-vignets">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to remove the password?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.hideResetPass}>Cancel</Button>
                        <Button color="primary" onClick={this.resetVignetPass}>Confirm</Button>
                    </ModalFooter>

                </Modal>
                }

            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        vignetsData  :state.vignets.vignetsData,
        uploadData : state.upload.uploadData,
        playlistData  :state.playlist.playlistData,
        pageSettingsData  : state.pages.pageSettings
    };

}
export default  withRouter(connect(mapStateToProps, {
    getDetail : vignetsActions.getVignetDetail,
    getVignetsProps : vignetsActions.getVignetProps,
    getVignetTags : vignetsActions.getVignetTags,
    getVignetNotes : vignetsActions.getVignetNotes,
    getVignetProjects : vignetsActions.getVignetProjects,
    saveTags : vignetsActions.saveTags,
    saveProject : vignetsActions.saveProject,
    removeTags : vignetsActions.removeTags,
    saveNote : vignetsActions.saveNote,
    getImagepurged : playlistActions.purgeImage,
    modalToggle : vignetsActions.toggleModal,
    removeProjects : vignetsActions.removeProjects,
    saveVignetPassword : vignetsActions.saveVignetPassword,
    removeVignetPassword : vignetsActions.removeVignetPassword

})(DetailContainer));



// WEBPACK FOOTER //
// ./src/components/vignets/DetailContainer.js